import { reactive, getCurrentInstance, ref, computed } from 'vue';
import { useInitActionCombo } from '../../../commons/combobox/initActionCombo.js';
import { useRemoteCombobox } from '@/setup/remoteCombobox.js';

export const useGLVoucherDetailData = () => {
  const { proxy } = getCurrentInstance();
  const { comboboxLoadData } = useRemoteCombobox();
  /**
   * Ẩn hiện container trên
   */
  const toggleAbove = ref(true);
  const toggleAboveHandler = () => {
    toggleAbove.value = !toggleAbove.value;
  };

  /**
   * Tạo object lưu dữ liệu các field
   */
  const comboboxDataRemote = reactive({
    account: [],
    bank: [],
    inventory_item_code: [],
    stock_code: [],
    debit_account: [],
    credit_account: [],
    tax_account: [],
    inventory_account: [],
    cogs_account: [],
    budget_source_name: [],
    budget_chapter_code: [],
    budget_sub_kind_item_code: [],
    budget_item_code: [],
    budget_sub_item_code: [],
    accounting_object_code: [],
    activity_name: [],
    statistic_code: [],
    invoice_form: [],
    currency: [], //Cb loại tiền
    project_code: [],
    bank_account: [],
    debit_accounting_object_code: [],
    credit_accounting_object_code: [],
    budget_fees_code: [],
    purchase_purpose_code: [],
  });

  /**
   * Biến dùng để disabled tiện ích
   * NNlinh 25.05.2022
   */
  const valueMode = computed(() => {
    return proxy.editMode != proxy.$ms.constant.FormState.View;
  });
  /**
   * Biến dùng để disabled Xóa nếu chứng từ đã ghi sổ
   * nthien4 31.08.2022
   */
  const disabledDelete = computed(() => {
    return proxy.editMode != proxy.$ms.constant.FormState.View || proxy.model.is_posted;
  });
  /**
   * Biến lưu trạng thái của form khi ở mode view
   * nthien4 10.08.2022
   */
  const valueModeView = computed(() => {
    return proxy.editMode == proxy.$ms.constant.FormState.View;
  });

  const disabledGetReceipt = computed(() => {
    return proxy.editMode == proxy.$ms.constant.FormState.View || proxy.model.IsElectronicTicket
  })
  /**
  * Biến disable lấy vé điện tử
  * NNLINH 12.09.2023
  */
  const disabledGetTicket = computed(() => {
    return (
      proxy.editMode == proxy.$ms.constant.FormState.View ||
      proxy.model.IsInvoiceGenerateData
    );
  });
  /**
   *Khai báo items của các button
   */
  const buttonUtilities = reactive([
    // {
    //   text: 'Thêm chứng từ',
    //   command: 'Add',
    //   disabledItem: valueMode,
    // },
    {
      text: 'Thêm chứng từ',
      command: 'Add',
      disabledItem: valueMode,
      IsSubMenu: true,
      icon: 'right-arrow-grey',
      position: {
        at: 'right+15 top',
        my: 'left top',
      },
      subItem: [
        {
          text: 'Chứng từ nghiệp vụ khác',
          command: 'Voucher',
        },
        {
          text: 'Tạm tính thuế TNDN',
          command: 'ProvisionalTaxInCome',
        },
        {
          text: 'Quyết toán thuế TNDN',
          command: 'FinalTaxInComeEnterprise',
        },
        {
          text: 'Tiền chuyển đi',
          command: 'BATransferWithdraw',
        },
        {
          text: 'Tiền chuyển đến',
          command: 'BATransferDeposit',
        },
      ],
    },
    {
      text: 'Thêm mới từ chứng từ hiện thời',
      command: 'Duplicate',
      disabledItem: valueMode,
      icon: 'right-arrow-grey',
      IsSubMenu: true,
      subItem: [
        {
          text: 'Phiếu thu',
          command: proxy.$ms.constant.Command.Duplicate,
          form: 'CAReceiptDetail',
          refType: proxy.$ms.constant.RefType.CAReceipt,
        },
        {
          text: 'Phiếu thu rút dự toán nhập quỹ',
          command: proxy.$ms.constant.Command.Duplicate,
          form: 'CAReceiptPlanWithdrawDetail',
          refType: proxy.$ms.constant.RefType.CAReceiptPlanWithdraw,
        },
        {
          text: 'Phiếu chi',
          command: proxy.$ms.constant.Command.Duplicate,
          form: 'CAPaymentDetail',
          refType: proxy.$ms.constant.RefType.CAPayment,
        },
        {
          text: 'Chuyển khoản kho bạc',
          command: proxy.$ms.constant.Command.Duplicate,
          form: 'BUTransferDetail',
          refType: proxy.$ms.constant.RefType.BUTransfer,
        },
        {
          text: 'Chứng từ nghiệp vụ khác',
          command: proxy.$ms.constant.Command.Duplicate,
          form: 'GLGeneralVoucherDetail',
          refType: proxy.$ms.constant.RefType.GLGeneralVoucher,
          initial: true,
        },
        {
          text: 'Chi tiền gửi',
          command: proxy.$ms.constant.Command.Duplicate,
          form: 'BAWithDrawDetail',
          refType: proxy.$ms.constant.RefType.BAWithDraw,
        },
      ],
    },
    // {
    //   text: 'Xóa chứng từ hiện thời',
    //   command: 'Delete',
    //   disabledItem: disabledDelete,
    // },
    {
      text: 'Lấy biên lai',
      command: 'GetReceipt',
      disabledItem: disabledGetReceipt,
    },
    {
      text: 'Lấy vé điện tử',
      command: proxy.$ms.constant.Command.GetElectronicTicket,
      disabledItem: disabledGetTicket,
    },
    {
      text: 'Xem số dư tài khoản',
      command: 'ViewAccount',
    },
    {
      text: 'Sao chép chứng từ',
      command: proxy.$ms.constant.Command.Copy,
      disabledItem: valueModeView,
    },
    {
      text: 'Cất thành định khoản tự động',
      command: proxy.$ms.constant.Command.AddAutoBusiness,
    },
  ]);

  const buttonPrints = reactive([
    {
      text: 'C02-10/NS: Phiếu điều chỉnh số liệu ngân sách(Mẫu nội dung chi tiết)',
    },
    {
      text: 'C02-10/NS: Phiếu điều chỉnh số liệu ngân sách(Thông tư số 19/2020/TT-BTC)',
    },
    { text: 'C37-HD: giấy đề nghị thanh toán' },
    { text: 'Chứng từ kế toán' },
    { text: 'Giấy đề nghị thanh toán tạm ứng' },
    { text: 'C37-HD: Giấy đề nghị thanh toán (Mẫu chi tiết từng dòng)' },
    {
      text: 'Chứng từ kế toán(Mẫu nguyên tệ)',
      seperatorBottom: true,
    },
    { text: 'Tùy chọn in' },
  ]);

  /**
   * Column của các grid editor
   */
  const columnParallel = reactive(initGridColumnParallel()); //hạch toán đồng thời

  function initGridColumnParallel() {
    return [
      {
        caption: 'Diễn giải',
        dataField: 'description',
        columnType: proxy.$ms.constant.ColumnType.Text,
        width: 250,
        editable: true,
        sortable: true,
      },
      {
        caption: 'TK Nợ',
        title: 'Tài khoản Nợ',
        dataField: 'debit_account',
        width: 100,
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        editable: true,
        sortable: true,
      },
      {
        caption: 'TK Có',
        title: 'Tài khoản Có',
        dataField: 'credit_account',
        width: 100,
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        editable: true,
        sortable: true,
      },
      {
        caption: 'Số tiền',
        dataField: 'amount_oc',
        width: 150,
        editable: true,
        columnType: proxy.$ms.constant.ColumnType.Number,
        formatType: proxy.$ms.constant.FormatType.Amount,
        summaryType: proxy.$ms.constant.SummaryType.Sum,
        sortable: true,
      },
      {
        caption: 'Quy đổi',
        dataField: 'amount',
        width: 150,
        editable: true,
        columnType: proxy.$ms.constant.ColumnType.Number,
        formatType: proxy.$ms.constant.FormatType.Amount,
        summaryType: proxy.$ms.constant.SummaryType.Sum,
        visible: false,
        sortable: true,
        rules: [
          {
            name: 'lessThanAmount',
            compareValue: 100000000000000,
          },
        ],
      },
      {
        caption: 'Nguồn',
        dataField: 'budget_source_name',
        width: 250,
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        editable: true,
        sortable: true,
      },
      {
        caption: 'Mã dự phòng',
        dataField: 'budget_provide_code',
        width: 120,
        columnType: proxy.$ms.constant.ColumnType.Text,
        editable: true,
        sortable: true,
      },
      {
        caption: 'Chương',
        dataField: 'budget_chapter_code',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        width: 100,
        editable: true,
        sortable: true,
        rules: [{ name: 'required' }],
      },
      {
        caption: 'Khoản',
        dataField: 'budget_sub_kind_item_code',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        width: 100,
        editable: true,
        sortable: true,
      },
      {
        caption: 'Mục',
        dataField: 'budget_item_code',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        width: 100,
        editable: true,
        sortable: true,
      },
      {
        caption: 'Tiểu mục',
        dataField: 'budget_sub_item_code',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        width: 100,
        editable: true,
        sortable: true,
      },
      {
        caption: 'Tiết tiểu mục',
        dataField: 'budget_detail_item_code',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        width: 100,
        editable: true,
        sortable: true,
      },
      {
        caption: 'Cấp phát',
        dataField: 'method_distribute_name',
        columnType: proxy.$ms.constant.ColumnType.Enum,
        editable: true,
        formatType: proxy.$ms.constant.FormatType.Enum,
        width: 150,
        sortable: true,
        enum: 'MethodDistributeType',
      },
      {
        caption: 'Nghiệp vụ',
        dataField: 'cash_withdraw_type_name',
        columnType: proxy.$ms.constant.ColumnType.Enum,
        editable: true,
        formatType: proxy.$ms.constant.FormatType.Enum,
        width: 150,
        sortable: true,
        enum: 'CashWithDrawType',
      },
      {
        caption: 'Hoạt động',
        dataField: 'activity_name',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        editable: true,
        width: 136,
        sortable: true,
      },
      {
        caption: 'CTMT, dự án',
        title: 'Chương trình mục tiêu, dự án',
        dataField: 'project_code',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        editable: true,
        width: 100,
        sortable: true,
      },
      {
        caption: 'Tài khoản NH, KB',
        title: 'Tài khoản ngân hàng, kho bạc',
        dataField: 'bank_account',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        editable: true,
        width: 100,
        sortable: true,
      },
      {
        caption: 'Phí, lệ phí',
        title: 'Phí, lệ phí',
        dataField: 'budget_fees_code',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        editable: true,
        width: 100,
        sortable: true,
      },
      {
        width: 100,
        caption: 'Đề tài',
        editable: true,
        sortable: true,
        dataField: 'topic_code',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        filterable: true,
      },
      {
        width: 100,
        caption: 'Hợp đồng',
        editable: true,
        sortable: true,
        dataField: 'contract_no',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
      },
      {
        width: 100,
        caption: 'Nhiệm vụ',
        dataField: 'task_code',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        editable: true,
        sortable: true,
      },
      {
        width: 100,
        caption: 'Nguồn năm trước',
        editable: true,
        sortable: true,
        dataField: 'is_source_before_year',
        columnType: proxy.$ms.constant.ColumnType.Checkbox,
      },
      {
        caption: '',
        dataField: 'rowAction',
        width: 80,
        columnType: proxy.$ms.constant.ColumnType.Action,
        sortable: false,
      },
    ];
  }

  /**
   * Hàm format tiền
   */
  function formatPrice(value) {
    if (value) {
      let val = (value / 1).toFixed(0).replace('.', ',');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    } else return 0;
  }
  /**
   * (custom) copy cột xuống các dòng dưới
   * @param {*} objAssign : Dữ liệu để merge vào dòng đó
   * @param {*} metaData : Dữ liệu dòng hoặc dữ liệu vừa chọn combo
   * @param {*} column : Cột đang copy
   * @param {*} $grid : Grid
   * @param {*} lastIndex: các dòng được copy rowIndex => lastIndex
   * @param {*} rowIndex: Dòng đang active
   * @param {*} isShowCombo: MetaData lấy từ dòng dữ liệu hay lấy từ xổ combo
   * DMNGOC (10.11.2022)
   */
  function copyDownRowExtend(objAssign, metaData, column, $grid, lastIndex, rowIndex, isShowCombo, callbackUpdateRow) {
    switch (column.dataField) {
      case 'accounting_object_code': // Đối tượng
        for (let i = rowIndex; i < lastIndex + 1; i++) {
          let item = $grid.dataView[i];
          item.accounting_object_name = metaData.accounting_object_name;
          item.company_tax_code = objAssign.company_tax_code || metaData.company_tax_code;
          item.accounting_object_address = objAssign.accounting_object_address || metaData.accounting_object_address || metaData.address;
        }
        break;
      case 'debit_accounting_object_code': // Đối tượng nợ
        for (let i = rowIndex; i < lastIndex + 1; i++) {
          let item = $grid.dataView[i];
          item.debit_accounting_object_id = isShowCombo
            ? metaData.accounting_object_id
            : metaData.debit_accounting_object_id;
          item.debit_accounting_object_name = isShowCombo
            ? metaData.accounting_object_name
            : metaData.debit_accounting_object_name;
        }
        break;
      case 'credit_accounting_object_code': // Đối tượng có
        for (let i = rowIndex; i < lastIndex + 1; i++) {
          let item = $grid.dataView[i];
          item.credit_accounting_object_id = isShowCombo
            ? metaData.accounting_object_id
            : metaData.credit_accounting_object_id;
          item.credit_accounting_object_name = isShowCombo
            ? metaData.accounting_object_name
            : metaData.credit_accounting_object_name;
        }
        break;
      case 'topic_code': // đề tài
        for (let i = rowIndex; i < lastIndex + 1; i++) {
          let item = $grid.dataView[i];
          item.topic_id = metaData.topic_id;
        }
        break;
      case 'contract_no': // hợp đồng
        for (let i = rowIndex; i < lastIndex + 1; i++) {
          let item = $grid.dataView[i];
          item.contract_id = metaData.contract_id;
        }
        break;
      case 'task_code': // nhiệm vụ
        for (let i = rowIndex; i < lastIndex + 1; i++) {
          let item = $grid.dataView[i];
          item.task_id = metaData.task_id;
        }
        break;
      case 'turn_over': // Giá tính thuế
        for (let i = rowIndex; i < lastIndex + 1; i++) {
          let item = $grid.dataView[i];
          // Tính lại tiền thuế
          item.tax_amount =
            item.tax_rate == this.$ms.constant.TaxRateInventory.NoSelected
              ? 0
              : ((objAssign.turn_over ?? 0) * ((item.tax_rate ?? 0) / 100)).toRound();
        }
        break;
      case 'tax_rate': // Thuế xuất
        for (let i = rowIndex; i < lastIndex + 1; i++) {
          let item = $grid.dataView[i];
          // Tính lại tiền thuế
          item.tax_amount =
            objAssign.tax_rate == this.$ms.constant.TaxRateInventory.NoSelected
              ? 0
              : ((item.turn_over ?? 0) * (objAssign.tax_rate / 100)).toRound();
        }
        break;
      case 'quantity':
      case 'amount':
      case 'amount_oc':
        const metaDataTracking = {
          tracking: {
            newVal: objAssign[column.dataField]
          }
        }
        const direction = lastIndex > rowIndex ? -1 : 1;
        while (lastIndex != rowIndex + direction) {
          proxy.changeDataBusiness($grid, column, lastIndex, metaDataTracking, callbackUpdateRow);
          lastIndex += direction;
        }
        break;
    }
  }
  /**
   * Khởi tạo config cho combobox trong grid
   */
  const {
    inventoryItemComboConfig, //mã hàng hóa
    stockComboConfig, // kho
    accountComboMostDetailConfig, //TK Nợ
    budgetSourceComboConfig, //Nguồn
    budgetProvideComboConfig,
    budgetDetailItemComboConfig,
    budgetKindItemComboConfig,
    budgetChapterComboConfig, // Chương
    budgetSubKindItemComboConfig, //Khoản
    budgetItemComboConfig, //Mục
    budgetSubItemComboConfig, //Tiểu mục
    accountingObjectComboConfig, //Cán bộ
    accountingObjectComboCreditConfig,
    accountingObjectComboDebitConfig,
    activityComboConfig, // hoạt động
    statisticComboConfig, //thống kê
    projectComboConfig,
    bankAccountComboConfig,
    budgetFeesComboConfig,
    purchasePurposeComboConfig,
    topicComboConfig,
    fundStructureComboConfig,
    contractComboConfig,
    TaskComboConfig,
    projectExpenseComboConfig
  } = useInitActionCombo(comboboxDataRemote, comboboxLoadData);

  return {
    toggleAbove,
    toggleAboveHandler,
    comboboxDataRemote,
    comboboxLoadData,
    columnParallel,
    inventoryItemComboConfig,
    stockComboConfig,
    accountComboMostDetailConfig,
    budgetSourceComboConfig, //Nguồn
    budgetDetailItemComboConfig,
    budgetProvideComboConfig,
    budgetKindItemComboConfig,
    budgetChapterComboConfig, // Chương
    budgetSubKindItemComboConfig, //Khoản
    budgetItemComboConfig, //Mục
    budgetSubItemComboConfig, //Tiểu mục
    accountingObjectComboConfig,
    accountingObjectComboCreditConfig,
    accountingObjectComboDebitConfig, //Cán bộ
    activityComboConfig, // hoạt động
    statisticComboConfig, //thống kê
    projectComboConfig,
    bankAccountComboConfig,
    budgetFeesComboConfig,
    purchasePurposeComboConfig,
    contractComboConfig,
    topicComboConfig,
    fundStructureComboConfig,
    TaskComboConfig,

    buttonUtilities,
    buttonPrints,
    formatPrice,
    copyDownRowExtend,
    projectExpenseComboConfig
  };
};
